import { CqsDto } from "@/lib/cqs";

export class IsEmailAlreadyTakenQuery extends CqsDto {
    public static CqsDtoType = "IsEmailAlreadyTakenQuery";

    constructor(
        public EmailAddress: string,
    ) {
        super();
    }
}

export class GetBoardData extends CqsDto {
    public static CqsDtoType = "GetBoardData";
}

export class GetCardBackData extends CqsDto {
    public static CqsDtoType = "GetCardBackData";
    constructor(public LinkedCardId: string) {
        super();
    }
}

export class CheckAccess extends CqsDto {
    public static CqsDtoType = "CheckAccess";
    constructor(public PersonalAccessToken: string = null, public IntegrationId: string = null) {super();}
}

export class GetBoardDataResult {
    public Cards: CardData[];
    public IsEditor: boolean;
    public CanSetEstimation: boolean;
    public StorymapUrl: string;
    public ColorsAndAnnotations: string[];
}

export class CardData {
    public Id: string;
    public Estimation: number;
    public Release: string;
    public Goal: string;
    public Step: string;
    public Color: string;
    public Annotations: string[];
}

export class GetCardBackDataResult extends CardData{
    public Attachments: Attachment[];
    public GoalDetails: string;
    public GoalUrl: string;
    public StepDetails: string;
    public StepUrl: string;
    public ReleaseDetails: string;
    public ReleaseUrl: string;
    public CardUrl: string;
}

export class Attachment{
    public Name: string;
    public Url: string;
    public ThumbnailUrl: string;
    public Extension: string;
    public IsWebLink: boolean;
    public IsImage: boolean;
    public IsFile: boolean;
    public AddedAt: string;
}
